import LandingPageLaunch from '#app/components/landing-page-launch.tsx'
import { type Route } from './+types/launch.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Podly — Become a Founding Creator' },
]

export default function LaunchRoute() {
	return <LandingPageLaunch />
}
